export const HEADER = "Say hello to a smarter booking experience";

export const BULLET_ONE = "Price prediction and alerts";
export const BULLET_TWO = "Price match guarantee";
export const BULLET_THREE = "Free price drop protection";

export const LOADING = "Loading...";
